import { RendererService } from './../renderer.service';
import { Mesh, Vector3, MeshBasicMaterial, SphereGeometry, DoubleSide } from 'three';
import { SceneService } from './../scene.service';
import { SphereModel } from './../../model';
import { Component, OnInit } from '@angular/core';
import { EntityComponent } from '../share/entity-component';

@Component({
  selector: 'ng3-sphere',
  templateUrl: './sphere.component.html',
  styleUrls: ['./sphere.component.css'],
})
export class SphereComponent extends EntityComponent<SphereModel> {

  constructor(sceneService: SceneService, renderer: RendererService) {
    super(sceneService, renderer);
  }
  createEntity(model: SphereModel) {
    const result = new Mesh(new SphereGeometry(model.radius, model.widthSegments, model.heightSegments),
      new MeshBasicMaterial({ color: 0xff0000 }));
    result.name = 'Sphere';
    result.position.copy(model.center);
    return  result;
  }
  updateEntity(model: SphereModel, entity: Mesh) {
    entity.position.copy(model.center);
    return entity;
  }
  defaultModel() {
    return new SphereModel(
      new Vector3(0, 0, 0),
      20,
      32,
      32,
      0,
      2 * Math.PI,
      0,
      0,
    );
  }


}
